import { isNil } from 'lodash';
import { CSSProperties, useMemo } from 'react';
import { Ellipsis } from 'components/elements';
import { StyledTableCell } from './TableCell.styled';
import { TableCellProps } from './types';

export const TableCell = <TEntity extends unknown>(props: TableCellProps<TEntity>) => {
  const { column, entity, style } = props;

  // Wrap cell content in ellipsis if required
  const children = useMemo(() => {
    // Use custom cell renderer if available
    if (column.renderer) {
      return column.renderer(entity);
    }

    // Extract entity value for the specified column/cell
    const value = entity[column.id];

    return column.ellipsis ? <Ellipsis>{value}</Ellipsis> : <>{value}</>;
  }, [column, entity]);

  // Build cell style object
  const customStyle = useMemo<CSSProperties>(
    () => ({
      ...style,
      width: !isNil(column.width) ? `${column.width}px` : undefined,
    }),
    [column.width, style],
  );

  return (
    <StyledTableCell $align={column.align} role="cell" style={customStyle}>
      {children}
    </StyledTableCell>
  );
};
